import _ from 'lodash';
import { auth } from '@/shared/lib';
import {
  FLAGGED_REASON,
  ORGANIZATION_SLUG,
  DOUBLE_HYPHEN_BULLET,
  BIOFLUX_ARTIFACT_FINDINGS,
  BIOTRES_ARTIFACT_FINDINGS,
  BIOCORE_PRO_ARTIFACT_FINDINGS,
} from '@/shared/config';

/**
 * Resolves a flagged-study reason into the issue title, description and troubleshooting steps shown to the clinic. Picks the findings table by device model, using the Biocore Pro table for a pending-upload flag on Biotres Pro, then rewrites the 12-hour wording to 4 hours when the organization read from auth is Vital Heart.
 *
 * @param text - Flagged reason text to look up.
 * @param model - Device model selecting the findings table, defaulting to Bioflux.
 * @returns The issue title, description and steps to try, with placeholders when no finding matches.
 */
const generateIssueFound = (text: any, model = 'Bioflux') => {
  let foundItem;
  if (text === FLAGGED_REASON.PENDING_UPLOAD && model === 'Biotres Pro') {
    foundItem = _.find(BIOCORE_PRO_ARTIFACT_FINDINGS, (x) => x.text === text);
  } else {
    const findings = model === 'Bioflux' ? BIOFLUX_ARTIFACT_FINDINGS : BIOTRES_ARTIFACT_FINDINGS;
    foundItem = _.find(findings, (x) => x.text === text);
  }

  // Get organization slug
  const organization = auth.userOrganization();
  const organizationSlug = organization?.slug;
  const isSpecialOrganization = organizationSlug === ORGANIZATION_SLUG.VITAL_HEART;

  // Adjust text for Offline issue if organization matches
  let issueFound = foundItem?.issue || DOUBLE_HYPHEN_BULLET;
  let description = foundItem?.description || DOUBLE_HYPHEN_BULLET;

  if (text === 'Offline' && isSpecialOrganization) {
    issueFound = issueFound.replace(/12 hours/g, '4 hours');
    description = description.replace(/12 hours/g, '4 hours');
  }

  return {
    issueFound,
    description,
    stepsToTry: foundItem?.stepsToTry || [],
  };
};

export { generateIssueFound };
